const SpacesIcon = () => `<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M10 1C8.89543 1 8 1.89543 8 3V9H3C1.89543 9 1 9.89543 1 11V21C1 22.1046 1.89543 23 3 23H8H17H21C22.1046 23 23 22.1046 23 21V3C23 1.89543 22.1046 1 21 1H10ZM17 21H21V3L10 3V9H15C16.1046 9 17 9.89543 17 11V21ZM8 11H3V21H8V11ZM10 21V11H15V21H10Z" fill="currentColor"/>
</svg>
  `;
export default SpacesIcon;
